import { unwrapRelationItem } from './relationItems'

// The text a card / table cell shows for a contact or company field. The value is a record, or — for a multiple-value field, or a
// field with relation_fields, whose links the API wraps as { attribute_id, value: record, relation_data } — a list of them.
// Imported by its own path (not through `shared/utils`, whose index pulls in the whole app).

const asList = (value) => (Array.isArray(value) ? value : [value]).filter(Boolean).map(unwrapRelationItem).filter(Boolean)

const joinLabels = (labels) => labels.filter(Boolean).join(', ')

const hasUid = (r) => r?.uid !== undefined && r?.uid !== null

// a contact's name; a contact with no name shows by its uid, and a value that is no contact at all shows nothing (never "Contact NaN")
export const contactName = (contact) => {
  const name = `${contact?.first_name || ''} ${contact?.last_name || ''}`.trim()
  if (name) return name
  return hasUid(contact) ? `Contact ${contact.uid % 9999}` : ''
}

export const contactLabel = (value) => joinLabels(asList(value).map(contactName))

export const companyLabel = (value) => joinLabels(asList(value).map(c => c?.name || (hasUid(c) ? `Company ${c.uid % 9999}` : '')))
